import {getErrorMessage} from '@Utils/error.util';
import type {AiContentVerificationFailure, AiContentVerificationResult} from './ai-content-verification.types';
import {AiContentVerificationErrorCode, VERIFY_AI_CONTENT_ENDPOINT, VERIFY_AI_CONTENT_TIMEOUT_MS, VERIFY_AI_CONTENT_UPLOAD_FIELD} from './ai-content-verification.types';

export async function verifyAiContent(file: File): Promise<AiContentVerificationResult> {
  const formData = new FormData();
  formData.append(VERIFY_AI_CONTENT_UPLOAD_FIELD, file);

  return (await window.PMW.writeLocal(VERIFY_AI_CONTENT_ENDPOINT, formData, 'json', {
    timeout: VERIFY_AI_CONTENT_TIMEOUT_MS,
    cache: false,
    processData: false,
    contentType: false,
  })) as AiContentVerificationResult;
}

export function getAiContentVerificationFailure(error: unknown): AiContentVerificationFailure {
  return {code: getVerificationErrorCode(error), message: getErrorMessage(error)};
}

function getVerificationErrorCode(error: unknown): AiContentVerificationErrorCode | null {
  if (!(error instanceof Error) || !('code' in error)) {
    return null;
  }

  return Object.values(AiContentVerificationErrorCode).find((code) => {
    return code === error.code;
  }) ?? null;
}
